"use strict";

var validComponents = ['basicPrograms', 'flatPrograms', 'deluxeProgramCoverPages', 'deluxeProgramInteriorPages'];

function convertComponents(from, to) {
  if (typeof from !== 'string') {
    throw new Error('from must be a string');
  }

  if (!validComponents.includes(from)) {
    throw new Error('from must be one of [' + validComponents.join(', ') + ']');
  }

  if (!Array.isArray(to)) {
    throw new Error('to must be an array');
  }

  if (!to.every(function (componentName) {
    return validComponents.includes(componentName);
  })) {
    throw new Error('each item in "to" must be one of [' + validComponents.join(', ') + ']. Got ' + to.join(', ') + '.');
  }

  return function converter() {
    var _this = this;

    this.components.forEach(function (component, index) {
      _this.components[index].backside_printing = null;
    });
    to.forEach(function (componentName) {
      _this[componentName].components = _this[from].all();
    });
    this[from].clear();

    if (from === 'deluxeProgramCoverPages') {
      this.deluxeProgramInteriorPages.clear();
    }
  };
}

module.exports = function (product, product_type) {
  var fn = function fn(x) {
    return x;
  };

  var from = product.product_type;
  var to = product_type;
  var deluxe = /deluxe/i;
  var basic = /basic/i;
  var flat = /flat/i;

  if (from.match(deluxe) && to.match(basic)) {
    fn = convertComponents('deluxeProgramCoverPages', ['basicPrograms']);
  }

  if (from.match(basic) && to.match(deluxe)) {
    fn = convertComponents('basicPrograms', ['deluxeProgramCoverPages', 'deluxeProgramInteriorPages']);
  }

  if (from.match(flat) && to.match(basic)) {
    fn = convertComponents('flatPrograms', ['basicPrograms']);
  }

  if (from.match(basic) && to.match(flat)) {
    fn = convertComponents('basicPrograms', ['flatPrograms']);
  }

  if (from.match(deluxe) && to.match(flat)) {
    fn = convertComponents('deluxeProgramCoverPages', ['flatPrograms']);
  }

  if (from.match(flat) && to.match(deluxe)) {
    fn = convertComponents('flatPrograms', ['deluxeProgramCoverPages', 'deluxeProgramInteriorPages']);
  }

  return fn;
};